import BookingService from "services/booking.service";

export type PartnerCheckoutResult = [Record<string, any> | null, unknown];

/** One in-flight HyperPay checkout per trip — avoids duplicate sessions from React Strict Mode. */
const checkoutRequests = new Map<string, Promise<PartnerCheckoutResult>>();

export function fetchPartnerCheckoutSession(
  tripId: string
): Promise<PartnerCheckoutResult> {
  const existing = checkoutRequests.get(tripId);
  if (existing) return existing;

  const request = (
    BookingService.processPartnerPayment(tripId) as Promise<PartnerCheckoutResult>
  ).finally(() => {
    if (checkoutRequests.get(tripId) === request) {
      checkoutRequests.delete(tripId);
    }
  });

  checkoutRequests.set(tripId, request);
  return request;
}
